import { Arrow } from 'themes/playful/components/Arrow/Arrow';

import { Marked, Title } from '../../../components/Title/Title';
import { InfoBlock } from './InfoBlock';

import s from './InfoBlock.module.css';
import s1 from 'themes/playful/components/PlayfulLayout.module.css';

type TProps = {
  aboutText: string;
};

export const About = ({ aboutText }: TProps) => {
  const hasAboutText = aboutText?.length > 0;

  if (!hasAboutText) {
    return null;
  }

  return (
    <InfoBlock className={s1.content}>
      <Title>
        <Marked>About</Marked>
      </Title>
      <span className={s.arrow}>
        <Arrow />
      </span>
      <p className={s.content}>{aboutText}</p>
    </InfoBlock>
  );
};
